import { render } from "./faq.vue?vue&type=template&id=dd88ec36&scoped=true"
import script from "./faq.vue?vue&type=script&lang=js"
export * from "./faq.vue?vue&type=script&lang=js"

import "./faq.vue?vue&type=style&index=0&id=dd88ec36&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd88ec36"]])

export default __exports__